/// <reference path="../../../WebUI/typings/tsd.d.ts" />
/// <reference path="ControllerBase.ts" />

import {ControllerBase} from "./ControllerBase";
import { DevPortalAppBase } from "../DevPortalAppBase";

/**
    * Redirects user to an app URL, after he/she logs in.
    */
export class RedirectController extends ControllerBase {
    constructor(app: DevPortalAppBase) {
        super(app);
    }

    public render(params: SimpleMvc.QueryParams): void {
        super.render(params);

        // We know the user is logged in because this method is only called if the user is logged in.
        // If the user is not logged in the login screen will be shown and this method will be called when the user logs in.

        var app = params['app'];
        if (app) {
            var newUrl = `/ConfigChannel.aspx?app=${app}`;
            window.location.assign(newUrl);
        }
    }
}




// WEBPACK FOOTER //
// ./Client/Controllers/RedirectController.ts